import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatFulfillByDate } from "@redotech/redo-fulfillment-operations-common/csv-columns/marketplace-fulfill-by-csv";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { useMerchantTimeZone } from "../../utils/use-merchant-time-zone";

const catalogEntry = fgColumnEntries.fulfillBy;

function FulfillByCell({ fulfillBy }: { fulfillBy: Date | null | undefined }) {
  const timeZone = useMerchantTimeZone();
  return <RedoTableTextCell text={formatFulfillByDate(fulfillBy, timeZone)} />;
}

export const MarketplaceFulfillByColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => <FulfillByCell fulfillBy={row.fulfillBy} />,
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
